import { createContext, useContext } from 'react';

// filename → download URL (the `file` field from DatasetDocument)
export type DocumentsMap = Map<string, string>;
export const DocumentsContext = createContext<DocumentsMap>(new Map());
export const useDocuments = () => useContext(DocumentsContext);
